<template>
    <div class="a-flex-rfsfs">
        <div class="s-search-label a-flex-rfsc a-mt-8" :style="{ 'width': labelwidth }" v-show="label">
            <span class="a-c-red a-fs-14" v-if="notnull">*</span>
            <div>{{ label }}</div>
        </div>
        <div>
            <!-- 粘贴上传提示（启用时显示） -->
            <div v-if="enablePaste" class="paste-tip a-mb-8">
                <el-tag type="info" size="small">
                    <i class="el-icon-document-copy"></i>
                    支持 Ctrl+V / Command+V 粘贴图片上传
                </el-tag>
            </div>
            
            <el-upload 
                :show-file-list="false" 
                :multiple='multiple' 
                :drag='drag' 
                :action="url" 
                :headers="headers" 
                :data="data" 
                :on-preview="handlePreview"
                :on-remove="handleRemove" 
                :before-remove="beforeRemove" 
                :limit="limit" 
                :on-exceed="handleExceed"
                :on-success="handleSuccess" 
                :file-list="fileList" 
                name="file" 
                :on-change="handleChange"
                :accept="acceptVali" 
                ref="upload"
            >
                <el-button style="border: 1px solid #DADDE0;border-radius: 4px;" icon="el-icon-upload2" v-if="!drag">
                    {{ enablePaste ? '上传或粘贴文件' : '上传文件' }}
                </el-button>
                <div v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                        <br v-if="enablePaste">
                        <small v-if="enablePaste" style="color: #909399;">支持 Ctrl+V 粘贴</small>
                    </div>
                </div>
            </el-upload>
            
            <div class="a-mt-16 a-flex-rfsc a-flex-wrap" v-if="fileList.length">
                <div class="img-content" v-for="(item, index) in fileList" :key="index">
                    <el-image
                        :src="item.url" 
                        style="width:100px;height:100px;border-radius: 4px;"
                        :preview-src-list='[item.url]'
                    ></el-image>
                    <i class="el-icon-error deleteImg" @click="beforeRemove(item, index)"></i>
                </div>
            </div>
            <div class="el-upload__tip a-c-999 a-fs-14">
                支持：{{ acceptStr }}格式
                <span v-if="enablePaste">，或粘贴板图片</span>
            </div>
        </div>

        <le-preview-img v-model="showPreviewImg" :imgList="previewList" :showIndex="showIndex"></le-preview-img>
    </div>
</template>

<script>
import Utils from '@/utils';

export default {
    props: {
        labelwidth: {
            type: String
        },
        label: {
            type: String,
        },
        value: {
            required: false,
            default: "",
        },
        notnull: {
            type: Boolean,
            default: false,
            required: false,
        },
        large: {
            type: Boolean,
            required: false,
            default: false,
        },
        acceptArr: {
            type: Array,
            default: () => [".png", ".jpg", ".jpeg"],
        },
        limit: {
            type: Number,
            default: 1,
        },
        uploadUrl: {
            type: String,
            default: ''
        },
        drag: {
            default: false,
            type: Boolean
        },
        multiple: {
            default: false,
            type: Boolean
        },
        // 新增：是否启用粘贴上传
        enablePaste: {
            type: Boolean,
            default: false
        },
        // 新增：粘贴上传的自定义提示文案
        pasteHint: {
            type: String,
            default: ''
        }
    },
    computed: {
        acceptStr() {
            return this.acceptArr.join("，");
        },
        acceptVali() {
            return this.acceptArr.join(",");
        },
    },
    watch: {
        value: {
            handler(val) {
                if (val != "") {
                    if (this.iswatch) {
                        if (typeof val == "string") {
                            let names = val.split("/");
                            let showName = names[names.length - 1];
                            if (!this.filesImg[showName]) {
                                this.fileList.push({
                                    name: showName,
                                    url: this.filesImg[showName] || val,
                                });
                            }
                        }
                        this.iswatch = false;
                    }
                }
            },
        },
        uploadUrl: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.url = this.$Config.axiosBaseUrl + val
                }
            }
        }
    },
    mounted() {
        // 启用粘贴功能时，绑定粘贴事件
        if (this.enablePaste) {
            this.bindPasteEvent();
        }
    },
    beforeDestroy() {
        // 移除粘贴事件监听
        if (this.enablePaste) {
            this.unbindPasteEvent();
        }
    },
    data() {
        return {
            url: this.$Config.axiosBaseUrl + this.$Config.apiUrl.uploadFile,
            headers: {
                token: Utils.getToken(),
                appId: this.$Config.appId,
            },
            data: {
                key: "company/upload",
            },
            fileList: [],
            filesImg: {},
            iswatch: true,
            showPreviewImg: false,
            previewList: [],
            showIndex: 0
        };
    },
    methods: {
        // 绑定粘贴事件
        bindPasteEvent() {
            document.addEventListener('paste', this.handlePaste);
        },
        
        // 移除粘贴事件
        unbindPasteEvent() {
            document.removeEventListener('paste', this.handlePaste);
        },
        
        // 处理粘贴事件
        handlePaste(e) {
            // 检查是否超出限制
            if (this.fileList.length >= this.limit) {
                this.$message.warning(`最多只能上传 ${this.limit} 个文件`);
                return;
            }
            
            const items = e.clipboardData && e.clipboardData.items;
            if (!items) return;
            
            let hasImage = false;
            
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                
                // 检查是否是图片类型
                if (item.type.indexOf('image') !== -1) {
                    hasImage = true;
                    const blob = item.getAsFile();
                    
                    if (blob) {
                        // 生成文件名
                        const timestamp = new Date().getTime();
                        const ext = blob.type.split('/')[1] || 'png';
                        const filename = `paste_${timestamp}.${ext}`;
                        
                        // 创建 File 对象
                        const file = new File([blob], filename, { type: blob.type });
                        
                        // 验证文件类型
                        if (!this.validateFileType(file)) {
                            this.$message.error(`文件格式不支持，请上传 ${this.acceptStr} 格式`);
                            continue;
                        }
                        
                        // 上传到服务器
                        this.uploadPastedFile(file);
                    }
                }
            }
            
            if (hasImage) {
                // 阻止默认粘贴行为
                e.preventDefault();
            }
        },
        
        // 验证文件类型
        validateFileType(file) {
            const ext = '.' + file.name.split('.').pop().toLowerCase();
            return this.acceptArr.some(accept => 
                ext === accept.toLowerCase() || 
                file.type.includes(accept.replace('.', ''))
            );
        },
        
        // 上传粘贴的文件
        uploadPastedFile(file) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('key', this.data.key || 'company/upload');
            
            // 显示上传中
            // const loading = this.$loading({
            //     lock: true,
            //     text: '粘贴上传中...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            
            // 使用 axios 或 fetch 上传
           this.$Axios._post({
                url: this.url,
                params: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': Utils.getToken(),
                    'appId': this.$Config.appId
                }
            }).then(res => {
                // 上传成功，添加到列表
                const newFile = {
                    name: file.name,
                    url: res.data,
                    status: 'success'
                };
                
                this.fileList.push(newFile);
                this.$emit("input", this.fileList.map(item => item.url));
            }).catch(err => {
                console.error('粘贴上传失败:', err);
                this.$message.error('上传失败，请重试');
            });
        },
        
        // 原有方法保持不变
        handlerChange(e) {},
        
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        
        handlePreview(index, fileList) {
            this.showPreviewImg = true;
            this.showIndex = index;
            if (fileList.length) {
                fileList.map((item, index) => {
                    this.previewList.push(item.url);
                });
            }
        },
        
        handleExceed(files, fileList) {
            if (fileList.length > 0) {
                if (fileList[0].status == "success") {
                    this.$message.warning(
                        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
                    );
                }
            }
        },
        
        beforeRemove(file, index) {
            let that = this;
            return this.$confirm(`确定移除 ${file.name}？`, {
                callback: (action) => {
                    if (action == "confirm") {
                        that.fileList.splice(index, 1);
                        this.$emit("input", this.fileList.map(item => item.url));
                    }
                },
            });
        },
        
        handleChange(file, fileList) {},
        
        handleSuccess(response, file, fileList) {
            if (fileList.every(f => f.status === 'success')) {
                const newFiles = fileList
                    .filter(f => f.response)
                    .map(f => ({
                        name: f.name,
                        url: f.response.data
                    }));
                this.fileList = [...this.fileList, ...newFiles];
                this.$emit("input", this.fileList.map(item => item.url));
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.el-upload__tip {
    white-space: nowrap;
}

/deep/ .el-upload-dragger {
    width: 240px !important;
    height: 120px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .el-icon-upload {
        font-size: 50px;
        margin: 0 auto !important;
    }
}

.img-content {
    width: 100px;
    height: 100px;
    position: relative;
    margin-right: 14px;

    .deleteImg {
        font-size: 18px;
        position: absolute;
        top: -8px;
        right: -8px;
        color: #606366;
        background: #fff;
        border-radius: 50%;
        cursor: pointer;
        
        &:hover {
            color: #f56c6c;
        }
    }
}

.lyimgbox {
    width: 50%;
}

// 新增：粘贴提示样式
.paste-tip {
    .el-tag {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
        
        i {
            margin-right: 4px;
        }
    }
}
</style>